import React from 'react';
import { string, bool } from 'prop-types';
import Tooltip from '@prisjakt/ui-tooltip-new';

const CountryFlag = props => {
  const { className, show, countryCode, altText, tooltip } = props;
  if (!show) {
    return null;
  }
  return (
    <Tooltip placement="left" title={tooltip} className={className}>
      <img
        title={altText}
        alt={altText}
        src={`https://cdn.pji.nu/g/rfe/icons/flags/16x11/${countryCode}.gif`}
      />
    </Tooltip>
  );
};

CountryFlag.propTypes = {
  show: bool,
  countryCode: string.isRequired,
  altText: string,
  className: string,
  tooltip: string,
};

CountryFlag.defaultProps = {
  altText: '',
  show: true,
  className: '',
  tooltip: '',
};

export default CountryFlag;
